import service from './service';
import apiUtil from './apiUtil';
import question from './question';
import placeAgent from './placeAgent';
import order from './order';
import activity from './activity';
import company from './company';


const params = _.extend(service, question, placeAgent, order, activity,company);

const generateApiMap = apiUtil.generateApiMap({
  ...params
});
export default {
  ...generateApiMap // 取出所有可遍历属性赋值在新的对象上
};



// WEBPACK FOOTER //
// ./src/api/index.js